<template>
  <HeadTitle
    title="Licencias y permisos"
    description="Lista de las solicitudes de licencias y sus estados de aprobación"
  />
  <divider></divider>
  <LicensesToolbar @open="openNewRequestDialog" />
  <LicensesTable
    v-model:expandedRows="expandedRows"
    v-model:filters="filters"
    :licenses="licenses"
    :statuses="statuses"
    :format-request-state="formatRequestState"
    :get-status-label="getStatusLabel"
    @row-expand="onRowExpand"
    @download-attachment="downloadAttachment"
    @delete-request="deleteConfirm"
  />
  <LicensesDialog
    v-model:visible="licenseDialog"
    :license="license"
    :license-definitions="licenseDefinitions"
    :submitted="submitted"
    :disabled-days="getDisabledDays"
    :disabled-dates="getDisabledDates"
    :get-badge="getBadge"
    :is-valid-to-save="isValidToSave"
    @license-type-change="onLicenseTypeChange"
    @calculate-date-end="calculateDateEnd"
    @select-file="saveFile"
    @remove-file="removeFile"
    @cancel="hideDialog"
    @save="saveRequest"
  />
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import HeadTitle from '@/shared/components/HeadTitle.vue'
  import LicensesToolbar from '../components/LicensesToolbar.vue'
  import LicensesTable from '../components/LicensesTable.vue'
  import LicensesDialog from '../components/LicensesDialog.vue'
  import { useLicenses } from '../composables/useLicenses'

  const { user } = storeToRefs(useUserStore())

  const {
    license,
    licenses,
    statuses,
    licenseDialog,
    submitted,
    licenseDefinitions,
    filters,
    expandedRows,
    getDisabledDays,
    getDisabledDates,
    getBadge,
    isValidToSave,
    saveFile,
    removeFile,
    openNewRequestDialog,
    onRowExpand,
    downloadAttachment,
    onLicenseTypeChange,
    deleteConfirm,
    formatRequestState,
    saveRequest,
    hideDialog,
    calculateDateEnd,
    getStatusLabel,
  } = useLicenses({
    employeeId: computed(() => user.value?.employeeId),
    autoLoad: true,
  })
</script>
